@use '@bitgmbh/ebiz-patterns-core/src/components/select';

:host {
  @extend .baywa-select;
}
